import { useSelector } from "react-redux";

import {
  selectUserClients,
  selectUserId,
  selectUserRoles,
} from "redux/slices/userSlice";
import K from "utilities/constants";
import { isPermissionPresent } from "utilities/generalUtility";

export const useIsAssignedToJob = (jobDetails) => {
  const userId = useSelector(selectUserId);
  const userRoles = useSelector(selectUserRoles);
  const userClients = useSelector(selectUserClients);

  if (isPermissionPresent(K.Permissions.SuperAdmin, userRoles)) {
    return true;
  }

  const isAssigned = !!jobDetails?.jobRecruiters?.some(
    (jobRecruiter) =>
      (jobRecruiter.recruiter?.id ?? jobRecruiter.id) === userId,
  );

  const managesClient =
    isPermissionPresent(
      K.Permissions.ManageCandidatesForAssignedClients,
      userRoles,
    ) && !!userClients?.some((client) => client.id === jobDetails?.clientsId);

  return isAssigned || managesClient;
};
